(function () {
  /* Weekly countdown timer used on product cards and product page */
  const COUNTDOWN_SELECTOR = '[data-weekly-countdown]';
  const DAY_MAP = {
    sunday: 0,
    monday: 1,
    tuesday: 2,
    wednesday: 3,
    thursday: 4,
    friday: 5,
    saturday: 6
  };
  const instances = new WeakMap();

  class WeeklyCountdown {
    constructor(el) {
      this.el = el;
      this.parts = {
        days: el.querySelector('[data-weekly-countdown-part="days"]'),
        hours: el.querySelector('[data-weekly-countdown-part="hours"]'),
        minutes: el.querySelector('[data-weekly-countdown-part="minutes"]'),
        seconds: el.querySelector('[data-weekly-countdown-part="seconds"]')
      };
      this.endDay = (el.dataset.weekEndDay || 'sunday').toLowerCase();
      this.endHour = parseInt(el.dataset.weekEndHour || '23', 10);
      this.endMinute = parseInt(el.dataset.weekEndMinute || '55', 10);
      this.interval = null;
      this.target = this.getNextTarget();
      this.handleAnimationEnd = (event) => {
        event.target.classList.remove('weekly-countdown__value--flip');
      };

      Object.values(this.parts).forEach((node) => {
        if (!node) return;
        node.dataset.value = node.textContent.trim();
        node.addEventListener('animationend', this.handleAnimationEnd);
      });

      this.start();
    }

    getNextTarget(fromDate) {
      const base = fromDate ? new Date(fromDate.getTime()) : new Date();
      const today = base.getDay();
      const desiredDay = DAY_MAP[this.endDay] ?? 0;
      let delta = desiredDay - today;

      const target = new Date(base.getTime());
      target.setHours(this.endHour, this.endMinute, 59, 999);

      if (delta < 0 || (delta === 0 && target <= base)) {
        delta += 7;
      }

      target.setDate(base.getDate() + delta);
      target.setHours(this.endHour, this.endMinute, 59, 999);
      return target;
    }

    start() {
      this.stop();
      this.tick();
      this.interval = window.setInterval(() => this.tick(), 1000);
    }

    stop() {
      if (this.interval) {
        window.clearInterval(this.interval);
        this.interval = null;
      }
    }

    tick() {
      const now = new Date();

      if (this.target <= now) {
        this.target = this.getNextTarget(now);
      }

      const diff = Math.max(0, this.target - now);
      const totalSeconds = Math.floor(diff / 1000);
      const days = Math.floor(totalSeconds / 86400);
      const hours = Math.floor((totalSeconds % 86400) / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      this.updatePart('days', days);
      this.updatePart('hours', hours);
      this.updatePart('minutes', minutes);
      this.updatePart('seconds', seconds);
    }

    updatePart(part, value) {
      const node = this.parts[part];
      if (!node) return;

      const padded = String(value).padStart(2, '0');
      if (node.dataset.value === padded) return;
      node.dataset.value = padded;
      node.classList.remove('weekly-countdown__value--flip');
      node.textContent = padded;
      requestAnimationFrame(() => {
        node.classList.add('weekly-countdown__value--flip');
      });
    }

    unload() {
      this.stop();
      Object.values(this.parts).forEach((node) => {
        if (!node) return;
        node.removeEventListener('animationend', this.handleAnimationEnd);
      });
    }
  }

  function initCountdowns(root = document) {
    root.querySelectorAll(COUNTDOWN_SELECTOR).forEach((el) => {
      if (instances.has(el)) return;
      instances.set(el, new WeeklyCountdown(el));
    });
  }

  function unloadCountdowns(root = document) {
    root.querySelectorAll(COUNTDOWN_SELECTOR).forEach((el) => {
      const instance = instances.get(el);
      if (!instance) return;
      instance.unload();
      instances.delete(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initCountdowns());
  } else {
    initCountdowns();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initCountdowns(event.target);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    unloadCountdowns(event.target);
  });
})();
